import {trackEvent} from "../src/track-event";
import {affiliatePattern} from "../src/affiliate-pattern";

const $ = jQuery;

$('.ntz-gutenberg-toc--item').on('click', function (e) {
    trackEvent(
        'Click',
        'ToC',
        e.currentTarget.href
    );
});

$('.js-track-ga').on('click', function (e) {
    trackEvent(
        $(e.currentTarget).data('gaAction') || window.location.href,
        $(e.currentTarget).data('gaLabel') || "Tracking",
        $(e.currentTarget).data('gaLabel') || e.currentTarget.href
    );
});


$(document).on('click', 'a', function (e) {
    const matches = affiliatePattern.exec(e.currentTarget.href);
    if (null === matches) {
        return;
    }

    trackEvent(
        'Click',
        'Affilialte ' + (matches[1] || matches[1] || ''),
        matches[0]
    );
});